var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ru:tip"},[_c('Chip',{attrs:{"background":"theme"}},[_vm._v(_vm._s(_vm.$t('components.tip.title')))]),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }